// config.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Injectable({ providedIn: 'root' })
export class ConfigService {
  readonly baseUrl = environment.apiUrl;
  readonly apiKey = environment.apikey;

}
